// Styles librairies
import '../libs/masterslider2/style/masterslider.css'
import '../../scss/components/masterSlider'

// Scripts librairies
import '../libs/masterslider2/jquery.easing.min.js'
/* global MasterSlider */
import '../libs/masterslider2/masterslider.min.js'

// Master slider init
const slider = new MasterSlider()
slider.control('arrows')
slider.control('thumblist', {
  autohide: false,
  dir: 'h',
  arrows: false,
  align: 'bottom',
  width: 180,
  height: 127,
  margin: 5,
  space: 5
})
slider.setup('masterslider', {
  width: 1200,
  height: 820,
  space: 5,
  view: 'fade',
  autoplay: true
})
